// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"6008":"97177442","6236":"19d85031"}[chunkId] + ".css";
};